import { prepareDocForCreate } from './helpers/firestoreHelpers'

const createSlide = ({boardRef, values}) => {
  return boardRef
    .collection('slides')
    .add(prepareDocForCreate(values))
}

export default createSlide
